import { CampaignMaterialsTemplatesController } from './campaign-materials-templates.controller'

function campaignMaterialsTemplates () {
  return {
    scope: {
      templates: '=',
      selectedMaterials: '=',
      headerButton: '<',
      selectedScheduleDate: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-materials-templates/campaign-materials-templates.html?$$REVISION$$',
    controller: CampaignMaterialsTemplatesController
  }
}

export { campaignMaterialsTemplates }
